import React, { useEffect, useState } from "react";
import { CreditInterface, CreditMonthsInterface } from "../../interfaces/credit/credit.interface";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { formatNumberWithSpaces } from "../../utils";
import { useCreditSelector } from "../../stores/product/product.store";

interface MonthsProps {
    credit: CreditInterface;
    months: CreditMonthsInterface[];
    onChangeMonth: (credit: CreditInterface, month: CreditMonthsInterface) => void;
}

export const Months: React.FC<MonthsProps> = ({ months, onChangeMonth, credit}) => {
    const selectedMonth = useCreditSelector((state: CreditState) => state.selectMonth);
    const [selected, setSelected] = useState(selectedMonth ? selectedMonth : months[0]);

    const changeMonth = (month: CreditMonthsInterface) => {
        setSelected(month);
    }

    useEffect(() => {
          if(selectedMonth?.id !== selected.id) {
              onChangeMonth(credit, selected);   
          }
    }, [credit, onChangeMonth, selected]);

    useEffect(() => {
        if(selectedMonth) {
            setSelected(selectedMonth);
        }
    }, [selectedMonth]);

    return (
        <div className="grid gap-4 grid-cols-3">
            { months.map(month =>
                <div
                    key={ month.id }
                    className={ `relative p-3 rounded-xl ${ selected.id === month.id ? 'text-black bg-yellow cursor-default' : 'text-white bg-[#50636c] cursor-pointer' }` }
                    onClick={ () => changeMonth(month) }>
                    { Boolean(month.badgeShow) && <div className="absolute right-0 top-0 bg-[#f78122] rounded-bl-lg font-semibold rounded-tr-lg p-1.5 text-black">{ month.badgeText }</div> }
                    <p className="text-2xl font-semibold">{ formatNumberWithSpaces(month.monthly) }</p>
                    <p className="text-lg">{ month.monthText }</p>
                </div>
            ) }
        </div>
    )
}